import React from "react"
import {Grid, GridColumn} from "@progress/kendo-react-grid"
import {useAppSelector} from "../../../store"
import {RootState} from "../../../rootReducer"
import {SpinnerGrid} from "../../../shared/CommonItems"

const TestTypeGrid = () => {
    const testtypeData = useAppSelector((state: RootState) => state.containers.dvsaTest.testTypeData)
    const testTypeLoading = useAppSelector((state: RootState) => state.containers.dvsaTest.testTypeLoading)

    return (
        <div className="position-relative">
            {testTypeLoading && <SpinnerGrid />}
            <Grid
                style={{
                    height: "calc(((100vh - 14rem) * 0.33) - 25px)",
                }}
                data={testtypeData}
            >
                <GridColumn field="testTypeCode" title="Test Type Code" />
                <GridColumn field="testTypeName" title="Test Type" />
            </Grid>
        </div>
    )
}

export default TestTypeGrid
